import { useState, useEffect, useCallback } from "react";
import {
  getRecentMovements,
  getItemMovements,
  recordStockAdjustment
} from "../services/inventoryService.js";

export function useInventory(selectedItemId = null) {
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMovements = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      if (selectedItemId) {
        const data = await getItemMovements(selectedItemId);
        setMovements(data);
      } else {
        const data = await getRecentMovements(50);
        setMovements(data);
      }
    } catch (err) {
      console.error("Failed to load inventory movements:", err);
      setError("Unable to load movements. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [selectedItemId]);

  useEffect(() => {
    fetchMovements();
  }, [fetchMovements]);

  const adjustStock = async (payload) => {
    const result = await recordStockAdjustment(payload);
    await fetchMovements();
    return result;
  };

  return {
    movements,
    loading,
    error,
    refetch: fetchMovements,
    adjustStock
  };
}

export default useInventory;
